import { render, staticRenderFns } from "./MyExpenses.vue?vue&type=template&id=5c1c2cf8&"
import script from "./MyExpenses.vue?vue&type=script&lang=js&"
export * from "./MyExpenses.vue?vue&type=script&lang=js&"
import style0 from "./MyExpenses.vue?vue&type=style&index=0&id=5c1c2cf8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports